export default {
  headerTitle: 'Transfer ID',
};
